
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../../constants/Config";
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let { lambda, appname } = window.app

const Category = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [errors, setErrors] = useState({});
    const [user, setUser] = useState("");
     const[formData,setFormData]=useState({
        name:"",
        logo:"",
        theme:"Default",
        status:""
     });
     const [show, setShow] = useState(false);
     const [fileError, setFileError] = useState("");
     const [filesData, setFilesData] = useState([])
     const [fileSizeError, setFileSizeError] = useState(false);
     const [files, setFiles] = useState([]);
     const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        type: '',
        message: ''
    });
    const [isDelete,setIsDelete]=useState(false)
    const [btnLoader,setBtnLoader]=useState(false)
    const [deleteLoader,setDeleteLoader]=useState(false)
    const [selectedButton, setSelectedButton] = useState(""); // Track selected button
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
const[image,setImg]=useState("");
   // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [categoryId,setCategoryId]=useState("")
    const[toastType,setToastType]=useState("")
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum]= useState();
    // const [sortDirection, setSortDirection] = useState('asc');
         

    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")

    // let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const {searchedFlag, setSearchedFlag,  isLoading, setIsLoading,userData, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="Categories")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)
    
      
    const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute !== undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
             setSearchedFlag(false);
             setUserSearch("")
         }
     }, [prevRoute]);
    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    useEffect(()=>{
        getCategories()
    },[])
    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
          toast[toastType](toastMessage, {
            position: "bottom-center",
            // autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
      
          // Clear the message after showing to prevent re-triggering
          setToastMessage && setToastMessage("");
        }
      }, [toastMessage, toastType]);

      useEffect(() => {
 
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);

const handleEdit=async(data)=>{
    // setIsLoading(true)
    // try {
    //     const token = localStorage.getItem("token");
    //     const response = await axios.post(`${lambda}getCategories?appname=${appname}&token=${token}&categoryid=${id}`);

    //     if (response?.data?.result === "Invalid token or Expired") {
    //         setShowSessionPopupup(true);
    //         setIsLoading(false)
    //     } else {
    //         console.log("responseeeeeeeeeeeeeeeeeeeee",response?.data?.result?.data?.[0])
    //         setFormData(response?.data?.result?.data?.[0])
    //         setErrors({})
    //         setIsLoading(false)
    //     }
    // } catch (error) {
    //     console.error("Error fetching categories:", error);
    // }
    setErrors({})
setFormData(data)
}



    const keyForRerender = `${rowsPerPage}_${data?.length}`;
     const columns = [
 
         {
             name: 'Name',
             selector: row => row?.name ?? "",
             sortable: true,
         },
         {
            name: 'icon',
            cell: (row) => row?.logo?.length > 0 ? <img src={`${image}${row.logo}`} alt="Image" /> : null,

            sortable: false,
        },
        {
          name: 'theme',
          selector: row => row?.theme ?? "",

          sortable: false,
      },
         {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },
        
 
        //  {
        //      name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
        //      cell: (props) => 
        //     //   {
        //         subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
        //     <div className="d-flex">
        //     {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
        //         <a onClick={e => handleViewUser(e, props.userid)}
        //             className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
        //                 className="mdi mdi-eye font-size-18"></i></a>}
        //     {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
        //         {props.userid === id ? <a
        //             className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
        //                 className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)}
        //                     className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
        //                         className="mdi mdi-pencil font-size-18"></i></a>}</>}
        // </div>
        //     //  }
        //      ,
        //      ignoreRowClick: true,
        //      allowOverflow: true,
        //      button: true,
        //  },
        {
            name:
             <>
            {(subValDashboard && subValDashboard.delete && subValDashboard.delete.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 
            'Actions' : null}</>
            // 'Actions'
            ,
            cell: (props) =>
                //  {
                     subValDashboard && subValDashboard.delete && subValDashboard.edit && (subValDashboard.delete.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">
                    {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
                        <a
                         className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-success action-button`}
                         onClick={()=>handleEdit(props)}
                        //  className={` text-success action-button`}
                         id="category-edit-button"><i className="mdi mdi-pencil font-size-18"></i></a>
                        } 
                    {subValDashboard && subValDashboard.delete && subValDashboard.delete.display === true && 
                        <a  style={{ position: "inherit"}} onClick={()=>handleDelete(props?.categoryid)}
                        className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
                        // className={`text-danger action-button`}
                        id="category-delete-button"><i className="mdi mdi-delete font-size-18"></i></a>
                         } 
                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },

     ];
 const handleDelete=(id)=>{
    setIsDelete(true)
    setCategoryId(id)
 }
     const handlePageChange = (page) => {
        GetTimeActivity()   
         setCurrentPage(page);
       };
     
       const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()   
         setRowsPerPage(newPerPage);
       };
     
// console.log('datattatatattatat',data)
    useEffect(() => {
        setRoute("user")
       //  GetClientDataContext()
        setActiveMenuId(200002)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
        userActivity();
    }, []);
     const userActivity = () => {
         let path = window.location.pathname.split("/");
         const pageName = path[path.length - 1];
         var presentTime = moment();
         let payload;

         payload = {
             "userid": localStorage.getItem("userId"),
             "pagename": pageName,
             "pageurl": window.location.href,
             "starttime": presentTime,
             "useragent": JSON.parse(localStorage.getItem("loc"))

         };


    const previousId = localStorage.getItem("previousid");
 const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


         axios({
             method: 'POST',
             url: urlLink,
             data: payload
         })
             .then(function (response) {
                 if (response?.data?.statusCode === 200) {
                     localStorage.setItem("previousid", response?.data?.result)
                 }
             });
     }
    const GetUserData = async () => {
        GetTimeActivity()   
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)
                // setActiveMenuObj(obj)

                console.log('response?.result?.[0]', response?.result?.[0])
            }
        } catch {
            console.log("error");
        }
    };
 

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
      
    }, []);

   //  useEffect(() => {
      

   //      console.log("trueeeeeeeeee",searchedFlag);
   //      if (searchedFlag) { 
   //          console.log("came") 
   //          handleSearch();
   //      } else {
   //          console.log("called get all deals") 
   //          User();
   //      }

   //  }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        GetTimeActivity()   
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token,
        })
            .then(function (response) {
                console.log("response", response);
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                setUser(response?.data?.result);
                setData(response?.data?.result?.data);
                global.exportExcelData = response?.data?.result?.data
                      


                setIsLoading(false);
                setUserSearch("");
                setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }



  

    const handleSearch = (e,flagggg) => {
        GetTimeActivity()   
        if(flagggg){
            setcurrentPage(1);
          } 
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if(flagggg === "normalsearch"){
            setSearchedFlag(true)
       }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
            })
                .then(function (response) {
                    if (response?.data?.result==="Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        console.log("response", response);
                        setUser(response?.data?.result);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                      


                        setIsLoading(false)
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const validateForm = () => {
        console.log("Validating Form...");
    
        let tempErrors = {};
        let isValid = true;
    
        if (!formData.name || formData.name.trim() === "") {
            tempErrors.name = "Category name is required";
            isValid = false;
        }
    
        if (!formData.status) {
            tempErrors.status = "Category status is required";  // Fixed typo
            isValid = false;
        }
    
        // if (!formData.logo || formData.logo.trim() === "") {
        //     tempErrors.logo = "Icon is required";
        //     isValid = false;
        // }
    
        setErrors(tempErrors);  // Update state with errors
    
        return isValid;  // Return validation result
    };
    


    
    const handleFileChange = (event) => {
        setErrors({...errors,logo:""})
        const selectedFile = event.target.files[0];
    
        if (!selectedFile) return; // Prevents error if no file is selected
    
        const allowedType = "image/svg+xml"; // Allow only SVG files
        let fileSize = 1048612 * 1; // 5MB
    
        if (selectedFile.type !== allowedType) {
            // setFileError("Only SVG images are allowed.");
            setToastMessage("Only SVG images are allowed.")
            setToastType("error")
            // setFileSizeError(true);
            return;
        }
    
        if (selectedFile.size < fileSize) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setFormData({ ...formData, logo: previewUrl }); // Store preview URL
            setFilesData([selectedFile]); // Store file data
           
        } else {
            setFileError("File size greater than 1MB.");
            setFileSizeError(true);
            event.target.value = null;

        }
    };
    const handleClick=(value)=>{
      setSelectedButton(value)
      setShow(true)
    }
    const handleSet=()=>{
      setFormData({...formData,theme:selectedButton})
      setShow(false)
    }
    const handleUploadSubmit = async () => {

        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
    const validate=validateForm()
    if(validate){
        setBtnLoader(true)
        if (filesData && filesData?.length > 0) {

            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    const updatedFiles = newFile;
                    console.log("updatedFiles", updatedFiles)
                    setFiles(updatedFiles);

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                    // handleSubmit(updatedFiles);
                                    handleCreate(updatedFiles)
                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        } else {
            // handleSubmit([], uniqueId);
         
                handleCreate([], uniqueId);
            
        }
    }
       

    }
    const handleCreate = async (filesData) => {
      let siteConfig = window?.site?.common;
      console.log("siteConfig", siteConfig);
    
      let appResourcesUrl = siteConfig?.imageCloudfront;
      let logoImage = ""; // Declare logoImage outside the if block
    console.log("filesDataaaaaaaa",filesData)
      if (filesData && filesData.length > 0) {
        logoImage = filesData?.[0]?.filepath; // Update the value of logoImage
      }
    
      console.log("logoImage", logoImage);
    
      try {
        console.log("form1212122", formData);
    
        const payload = {
          createdBy: {
            name: userData?.name,
            userid: useruniqueid,
          },
          name: formData?.name,
          logo: filesData?.length > 0 ? logoImage : formData?.logo,
          status: formData?.status,
          theme:formData?.theme
        };
    
        if (formData?.categoryid) {
          try {
            const response = await axios.post(
              `${lambda}updateCategory?appname=${appname}&userid=${useruniqueid}&categoryid=${formData?.categoryid}`,
              payload
            );
    
            console.log("response", response);
            if (response?.data?.result === "Category name already exists") {
              setToastMessage("Category name already exists.");
              setToastType("warning");
              setIsLoading(false);
              setBtnLoader(false);
            }else
            if (response?.data?.result === "Updated Succesfully") {
              setToastMessage("Category Updated Successfully");
              setToastType("success");
              setFilesData([])
              setFormData({ name: "", status: "", logo: "", categoryid: "",theme:"Default" });
              setTimeout(() => {
                getCategories();
              }, 2000);
            }
          } catch (error) {
            console.error("Error updating category:", error);
            setToastMessage("Failed to update category");
            setToastType("error");
          } finally {
            setBtnLoader(false);
          }
        } else {
          console.log("payload", payload);
          try {
            const token = localStorage.getItem("token");
            const response = await axios.put(
              `${lambda}addCategory?appname=${appname}&token=${token}`,
              payload
            );
    
            if (response?.data?.result === "Category name already exists") {
              setToastMessage("Category name already exists.");
              setToastType("warning");
              setIsLoading(false);
              setBtnLoader(false);
            } else {
              console.log("response:", response);
              setIsLoading(false);
              setToastMessage("Category Created Successfully");
              setToastType("success");
              setFilesData([])
              setFormData({ name: "", status: "", logo: "", categoryid: "",theme:"Default" });
              setTimeout(() => {
                getCategories();
              }, 2000);
    
              setBtnLoader(false);
            }
          } catch (error) {
            console.error("Error while adding category:", error);
            setIsLoading(false);
          }
        }
      } catch (error) {
        setAlertConfig({
          title: "Error",
          type: "error",
          message: error.response?.data?.message || "Something went wrong",
        });
        setShowAlert(true);
      }
    };
    
    const handleButtonClick = (value) => {
      setSelectedButton(value);
    };
const handleDeleteCategory = async () => {
  setDeleteLoader(true)
    try {
    //   console.log("formData before deletion:", formData);
  
      const payload = {
        // archivedBy: {
        //   name: userData?.name, 
        //   userid: useruniqueid
        // },
        status: "ARCHIVE",
        // archivedOn: new Date().toISOString(),
        // logo: filesData?.length > 0 ? logoImage : formData?.logo,
        
      };
  
      
        const response = await axios.post(
          `${lambda}updateCategory?appname=${appname}&userid=${useruniqueid}&categoryid=${categoryId}`,
          payload
        );
  
        console.log("API Response:", response);
  
      setDeleteLoader(false)
          setToastMessage(" Category Deleted Successfully");
          setToastType("success");
  setIsDelete(false)
          // Reset form after update
          setFormData({ name: "", status: "", logo: "", categoryid: "",theme:"Default" });
  
          setTimeout(() => {
            getCategories(); // Fetch updated category list
          }, 2000); // Ensure toast is visible before refresh
        
      
    } catch (error) {
      console.error("Error updating category:", error);
      setToastMessage("Failed to update category");
      setToastType("error");
    } finally {
      setBtnLoader(false);
    }
  };
  
  const handleCancel=()=>{
    setIsDelete(false)
  }
  
const getCategories = async () => {
    setIsLoading(true)
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${lambda}getCategories?appname=${appname}&token=${token}`);

        if (response?.data?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
            setIsLoading(false)
        } else {
            setData(response?.data?.result?.data);
            setIsLoading(false)
        }
    } catch (error) {
        console.error("Error fetching categories:", error);
    }
};
console.log("errorsssssssssssssssssssssssssss",errors)
const handleRemove=()=>{
  setFilesData([])
    setFormData({...formData,logo:""})
}
const handleChange = (event) => {
    const { name, value } = event.target;

  if (name === "name") {
        // Validate phone number: only numbers and a maximum of 10 digits
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the phone number field
        }));

        setErrors({ ...errors, name: "" })

    }  else if (name === "status") {
        // Validate phone number: only numbers and a maximum of 10 digits
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the phone number field
        }));

        setErrors({ ...errors, status: "" })

    } else {
        // Allow normal updates for other fields
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    }
};


console.log("formData-------------------------->",formData)
   //  const handleKeypress = (e) => {
   //      //it triggers by pressing the enter key
   //      GetTimeActivity()   
   //      if ((e.key === "Enter")) {
   //          setTimeout(function () {
   //              handleSearch();
   //          }, 1000);
   //      }
   //  };
    const handleAddUser = (e) => {
        GetTimeActivity()   
        navigate("/adduser");
    }
const handleClose=()=>{
    setIsDelete(false)
}
    const handleEditUser = (e, paramuserid) => {
        console.log('paramuserid',paramuserid)
        GetTimeActivity()   
        navigate("/edituser/" + paramuserid);
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()   
        console.log('paramuserid',paramuserid)

        navigate("/viewuser/" + paramuserid);
    }
console.log("selectedButtonnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn",selectedButton)
    const clearSearch = () => {
        GetTimeActivity()   
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return(
            
            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No users found. </p>
                </div> </div>
        )
    }
    const handleExport = () => {
     
              // let k = defaultData || exportExcelData
          const modifiedArray = global.exportExcelData.map(( each,i) => ({
                "S.NO":i+1,
                "NAME": each?.name ?? "",
                "USER TYPE": each?.type ?? "",
                "EMAIL ID":   typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
                "PHONE NUMBER": each?.phone ?? "" ,
                "STATUS": each?.status?? "",
              
              }));
         
            exportToExcel(modifiedArray, "data");
           
        }
        function exportToExcel(jsonData, fileName) {
            delete jsonData['_id'];
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
            //FileSaver.saveAs(data, `${fileName}.xlsx`);
            FileSaver.saveAs(data1, `UsersData.xlsx`);
            console.log('data22222--->',data)
        }
        const customSort = (rows, selector, direction) => {
            const sortedData = rows.slice().sort((rowA, rowB) => {
              // use the selector function to resolve your field names by passing the sort comparators
              // const aField = selector(rowA);
        const aField = String(selector(rowA)).toLowerCase();

              //  const bField = selector(rowB);
          const bField = String(selector(rowB)).toLowerCase();
          
              let comparison = 0;
          
              if (aField > bField) {
                comparison = 1;
              } else if (aField < bField) {
                comparison = -1;
              }
          
              return direction === 'desc' ? comparison * -1 : comparison;
            });
          
            // Log the sorted data to the console
            // setSortedRecomData(sortedData)
            global.exportExcelData = sortedData
            // console.log('Sorted Data------>:', sortedData);
          
            return sortedData;
          };    
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              {isLoading?<Loader/>:
             <div id="userManagement" className="main-content user-management">
             <div id="pageContent" className="page-content">
               <div id="containerFluid" className="container-fluid">
                 <div id="breadcrumbRow" className="row breadcrumb">
                   <div id="breadcrumbCol" className="col-lg-12">
                     <div id="breadcrumbWrapper" className="d-flex align-items-center">
                       <div id="breadcrumbContent" className="flex-grow-1">
                         <h4 id="categoryManagementTitle" className="mb-2 card-title">CATEGORY MANAGEMENT</h4>
                         <p id="menuPath" className="menu-path">
                           <span>Spot Management</span> / <b>ADD CATEGORY</b>
                         </p>
                       </div>
                     </div>
                   </div>
                 </div>
           
                 <div id="tableDataRow" className="row table-data">
                   <div id="tableDataCol" className="col-12">
                     <div id="categoryCard" className="card">
                       <div id="categoryCardBody" className="card-body">
                         <div id="addCategoryRow" className="row add-category-page-style">
                           <div id="addCategoryCol" className="col-md-3 pe-1">
                             <div id="basicPlanLeft" className="basic_plan">
                               <h4 id="addCategoryTitle" className="form-title">ADD CATEGORY</h4>
           
                               <label id="categoryNameLabel" className="form_label mt-2 span-style">CATEGORY NAME<span className="required">*</span></label>
                               <div id="categoryNameInputGroup" className="input-group mb-4 mr-sm-2 error-mssg-style">
                                 <div id="categoryNameInputPrepend" className="input-group-prepend">
                                   <div id="categoryNameIcon" className="input-group-text">
                                     <span className="material-symbols-outlined">add_business</span>
                                   </div>
                                 </div>
                                 <input id="categoryNameInput" className="form-control" placeholder="Category Name" type="text" name="name" value={formData?.name} onChange={handleChange} />
                                 {errors && <span id="categoryNameError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.name}</span>}
                               </div>
           
                               <label id="uploadIconLabel" className="form_label  span-style">UPLOAD ICON</label>
                               {formData?.logo?.length > 0 ? (
                                 <div id="uploadIconPreview" className="upload-icon">
                                   <div id="uploadIconBlock" className="img_block add_img_block">
                                     <span id="removeIconBtn" className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>
                                   { formData?.logo?.startsWith("blob:")? <img id="activeImg" src={formData?.logo} width={150} />: <img id="activeImg" src={` ${image}${formData?.logo}`} width={150} /> }    
                                   </div>
                                 </div>
                               ) : (
                                 <div>
                                   <input type="file" accept="image/*" className="d-none" id="uploadIcon" onChange={handleFileChange} />
                                   <label htmlFor="uploadIcon" id="uploadIconBtn" className="stroke-button logo-width">
                                     ADD ICON <span className="material-icons">file_upload</span>
                                   </label>
                                   {/* {errors && <span id="uploadIconError" className="errormsg" style={{ fontWeight: 'bold', color: 'red',marginLeft: "5px" }}>{errors?.logo}</span>} */}
                                 </div>
                               )}
             <label id="statusLabel" className="form_label mt-3 span-style">THEME<span className="required">*</span></label>
                              
                               <div>
                                   {/* <input type="file" accept="image/*" className="d-none" id="uploadIcon" onChange={handleFileChange} /> */}
                                   <button  id="uploadIconBtn" className="stroke-button logo-width" onClick={()=>handleClick(formData?.theme)}>
                                  {formData?.theme}
                                   </button>
                                   {/* {errors && <span id="uploadIconError" className="errormsg" style={{ fontWeight: 'bold', color: 'red',marginLeft: "5px" }}>{errors?.logo}</span>} */}
                                 </div>
                                 <label id="statusLabel" className="form_label mt-3 span-style">STATUS<span className="required">*</span></label>
                               <div id="statusInputGroup" className="input-group mb-2 mr-sm-2 error-mssg-style">
                                 <select id="statusSelect" className="form-select select-style" name="status" value={formData?.status} onChange={handleChange}>
                                   <option value="">Status</option>
                                   <option value="ACTIVE" id="statusActive">ACTIVE</option>
                                   <option value="INACTIVE" id="statusInActive">IN ACTIVE</option>
                                 </select>
                                 {errors && <span id="statusError" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errors?.status}</span>}
                               </div>
           {subValDashboard && subValDashboard.add && subValDashboard.add.display===true &&  <button id="saveCategoryBtn" className={subValDashboard && subValDashboard.add && subValDashboard.add.enable===true ?"fill-btn save_continue mt-4 float-none":"fill-btn save_continue mt-4 float-none pe-none"} onClick={handleUploadSubmit} disabled={btnLoader}>
                                 {btnLoader && <img id="loadingIcon" src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" alt="Loading" />}
                                 {formData?.categoryid ? "Update" : "Create"}
                               </button> }
                              
                             </div>
                           </div>
           
                           <div id="categoriesCol" className="col-md-9 ps-1">
                             <div id="basicPlanRight" className="basic_plan">
                               <h4 id="categoriesTitle" className="form-title">CATEGORIES</h4>
                               <DataTable
                                 id="categoriesTable"
                                 key={keyForRerender}
                                 columns={columns}
                                 keyField="_id"
                                 data={data}
                                 direction="auto"
                                 highlightOnHover
                                 fixedHeaderScrollHeight="300px"
                                 pagination
                                 responsive
                                 persistTableHead
                                 striped
                                 defaultSortField="name"
                                 noDataComponent={customNoRecords()}
                                 paginationTotalRows={data.length}
                                 onChangeRowsPerPage={handlePerRowsChange}
                                 onChangePage={handlePageChange}
                                 paginationPerPage={rowsPerPage}
                                 paginationDefaultPage={currentPageNew}
                                 paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                 paginationComponentOptions={{
                                   rowsPerPageText: 'Per page:',
                                   rangeSeparatorText: 'of',
                                   noRowsPerPage: false,
                                   selectAllRowsItem: false,
                                   selectAllRowsItemText: 'All',
                                 }}
                                 progressPending={isLoading}
                                 progressComponent={<TableLoader />}
                               />
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
            
             <Modal className="new-set-modal" show={isDelete} id="category-modal">
  <div className="modal-dialog modal-dialog-centered" id="category-modal-dialog">
    <div className="modal-content rounded-4" id="category-modal-content">

      {/* Modal Header */}
      <div className="modal-header border-0 justify-content-center position-relative" id="category-modal-header">
        <button className="close-btn" onClick={e => handleClose()} id="category-close-btn">
          <span className="material-icons">close</span>
        </button>
      </div>

      {/* Modal Body */}
      <div className="modal-body text-center" id="category-modal-body">
        <img
          src={`${image}${appname}/images/web/disco-ball.gif`}
          alt="Delete Icon"
          className=""
          style={{ width: "100px", height: "100px" }}
          id="category-delete-icon"
        />
        <h3 className="modal-sm-heading" id="category-modal-title">Delete</h3>
        <p className="modal-text" id="category-modal-text">
          The changes cannot be undone.<br />
          Do you want to delete?
        </p>
      </div>

      {/* Modal Footer */}
      <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="category-modal-footer">
        <button className="stroke-btn-style" onClick={handleCancel} id="category-cancel-btn">Don’t Delete</button>
        <button className="fill-btn save_continue" onClick={handleDeleteCategory} id="category-confirm-btn">
          {deleteLoader ? (
            <img
              src={`${image}${appname}/images/web/rotate_right.svg`}
              className="loading-icon"
              alt="Loading"
              id="category-loader-icon"
            />
          ) : null}
          Yes
        </button>
      </div>

    </div>
  </div>
</Modal>


{/* <Modal show={show} onHide={() => setShow(false)} centered  >
        <Modal.Header closeButton>
          <Modal.Title>SELECT THEME</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      <div className="d-flex justify-content-center gap-2 flex-wrap">
        <button
          className={`btn btn-outline-primary ${selectedButton === "Default" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Default")}
        >
          Default
        </button>
        <button
          className={`btn btn-outline-secondary ${selectedButton === "Sunset Red" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Sunset Red")}
        >
          Sunset Red
        </button>
        <button
          className={`btn btn-outline-success ${selectedButton === "Ocean Blue" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Ocean Blue")}
        >
          Ocean Blue
        </button>
        <button
          className={`btn btn-outline-danger ${selectedButton === "Calm Forest" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Calm Forest")}
        >
          Calm Forest
        </button>
        <button
          className={`btn btn-outline-danger ${selectedButton === "Fire Red" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Fire Red")}
          
        >
          Fire Red
        </button>
      </div>
    </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleSet} >
            SET
          </button>
          
        </Modal.Footer>
      </Modal> */}
     <Modal show={show} onHide={() => setShow(false)} backdrop="static" centered className="theme-modal-wrapper">
  <Modal.Header closeButton>
    <Modal.Title>SELECT THEME</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="row theme-scroll-container px-2 ">

      <div className="col-md-3 theme-item">
        <button
          id="theme-default"
          className={`theme-card ${selectedButton === "Default" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Default")}
        >
          <img src={`${image}${appname}/images/web/MapView-1.png`} alt="Default Theme" className="theme-img" />
        </button>
        <h6 className="form-title mt-3 text-center">Default</h6>
      </div>

      <div className="col-md-3 theme-item">
        <button
          id="theme-sunset-red"
          className={`theme-card ${selectedButton === "Sunset Red" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Sunset Red")}
        >
          <img src={`${image}${appname}/images/web/MapView-2.png`} alt="Sunset Red Theme" className="theme-img" />
        </button>
        <h6 className="form-title mt-3 text-center">Sunset Red</h6>
      </div>

      <div className="col-md-3 theme-item">
        <button
          id="theme-ocean-blue"
          className={`theme-card ${selectedButton === "Ocean Blue" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Ocean Blue")}
        >
          <img src={`${image}${appname}/images/web/MapView-3.png`} alt="Ocean Blue Theme" className="theme-img" />
        </button>
        <h6 className="form-title mt-3 text-center">Ocean Blue</h6>
      </div>

      <div className="col-md-3 theme-item">
        <button
          id="theme-calm-forest"
          className={`theme-card ${selectedButton === "Calm Forest" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Calm Forest")}
        >
          <img src={`${image}${appname}/images/web/MapView-4.png`} alt="Calm Forest Theme" className="theme-img" />
        </button>
        <h6 className="form-title mt-3 text-center">Calm Forest</h6>
      </div>

      <div className="col-md-3 theme-item">
        <button
          id="theme-fire-red"
          className={`theme-card ${selectedButton === "Fire Red" ? 'active' : ''}`}
          onClick={() => handleButtonClick("Fire Red")}
        >
          <img src={`${image}${appname}/images/web/MapView-5.png`} alt="Fire Red Theme" className="theme-img" />
        </button>
        <h6 className="form-title mt-3 text-center">Fire Red</h6>
      </div>

    </div>
  </Modal.Body>

  <Modal.Footer className="justify-content-start">
    <button className="fill-btn save_continue" onClick={handleSet} id="theme-set-btn">
      SET
    </button>
  </Modal.Footer>
</Modal>

             <SweetAlert
               id="tableErrorAlert"
               show={tableErrMsg}
               custom
               confirmBtnText="OK"
               confirmBtnBsStyle="primary"
               title={"Something went wrong. Please reload again."}
               onConfirm={() => setTableErrMsg(false)}
             />
           
             <SweetAlert
               id="fileSizeErrorAlert"
               show={fileSizeError}
               warning
               confirmBtnText="OK"
               confirmBtnBsStyle="danger"
               title={fileError}
               onConfirm={() => setFileSizeError(false)}
             />
           
             <SweetAlert
               id="genericAlert"
               show={showAlert}
               title={alertConfig.title}
               type={alertConfig.type}
               onConfirm={() => setShowAlert(false)}
             >
               {alertConfig.message}
             </SweetAlert>
           
             <Footer id="footerComponent" />
           
             <ToastContainer
               id="toastContainer"
               position="bottom-center"
               autoClose={3000}
               hideProgressBar={false}
               newestOnTop={false}
               closeOnClick
               rtl={false}
               pauseOnFocusLoss
               draggable
               pauseOnHover={false}
               theme="light"
             />
           </div>
           }
                    
             


            </div>
        </>
    );
};

export default Category;
